import { MultiSelect, MultiSelectModel } from '@syncfusion/ej2-dropdowns';

import { EditableClientProps } from '@/shared/types/editable';

import { dropDownlistModel } from '@/front/editable/drop-down-list';
import { input } from '@/front/editable/input';
import { addValidation, setControl } from '@/front/editable/state';
import { change } from '@/front/editable/utils';

export const initMultiSelect = (p: EditableClientProps, e: HTMLElement) => {
  const dropDownList = new MultiSelect({
    ...multiSelectModel(p),
    change: change(e),
  });

  dropDownList.appendTo(input(p, e));

  setControl(p.id, dropDownList);

  addValidation(p, e);
};

export const multiSelectModel = (p: EditableClientProps): MultiSelectModel & { value?: string[] } => ({
  ...dropDownlistModel(p, { multiselect: true }),
  value: p.value === null ? [] : p.value,
  mode: 'Box',
  allowCustomValue: p.allowCustomValue,
  allowFiltering: p.allowCustomValue ? true : p.allowFiltering,
  ...(p.noRecordsTemplate ? { noRecordsTemplate: p.noRecordsTemplate } : {}),
});
